<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12" sm="4" offset-sm="4">
        <v-card class="text-center mt-12">
          <v-card-text>
            <div v-if="!$route.query.error">
              <h2>Your will is being generated</h2>
              <p>
                Your will will open in this tab. Please be patient, this can
                take up to 1 minute.
              </p>
              <p>
                Your will is <strong>password protected</strong>, please use
                your ID or passport number as the password
              </p>
              <v-progress-circular indeterminate color="primary" />
            </div>
            <div v-else-if="$route.query.error == '2'">
              <h2>Your Executor selection appears to be invalid</h2>
              <p>
                Please edit your Executor in your people overview to resolve the
                issue.
              </p>
            </div>
            <div v-else>
              <h2>Oops something went wrong</h2>
              <p>Please try again or contact support for assistance.</p>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'DownloadWillLoadingPage',
  };
</script>
